export default "/StatisticheIsaWeb/dist/img/AE_mono_152.png";